var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5833 7.61429L9.41667 5.84286V16.3857L14.5833 18.1571V7.61429ZM15.3333 20L8.66667 17.7143L4.64865 19.0919C3.35051 19.537 2 18.5723 2 17.2V7.71429C2 6.85971 2.54297 6.09955 3.35135 5.82239L8.66667 4L15.3333 6.28571L19.3514 4.90811C20.6495 4.46303 22 5.42768 22 6.8V16.2857C22 17.1403 21.457 17.9004 20.6486 18.1776L15.3333 20ZM16.0833 18.1571L20.1622 16.7587C20.3643 16.6894 20.5 16.4994 20.5 16.2857V6.8C20.5 6.45692 20.1624 6.21576 19.8378 6.32703L16.0833 7.61429V18.1571ZM7.91667 5.84286V16.3857L4.16216 17.673C3.83763 17.7842 3.5 17.5431 3.5 17.2V7.71429C3.5 7.50064 3.63574 7.3106 3.83784 7.24131L7.91667 5.84286Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.4b91a506d283d30d2f3f9eef54512885.svg";
export { ForwardRef as ReactComponent };